import moment from "moment";
import C from "./constant"
import store from "./store";
import Perference from "./perference";


var MyInfo =
  {
    uid: 0,
    type: 'U',
    phone: '',
    businessCard: '',
    affiliation: '',
    name: '',
    point: 0,
    push: 'N',
    pushVibration: 'N',
    pushStartTime: '',
    pushEndTime: '',
    latitude: 0.0,
    longitude: 0.0,
    address: '',
    roadAddress: '',
    tmpAddress: '',
    tmpRoadAddress: '',
    tmpSearchAddress: '',
    tmpLatitude: 0.0,
    tmpLongitude: 0.0,
    usageDate: '',
    accessToken: '',
    fcmToken: '',
    madeCnt: 0,
    pushCnt: 0,
    pushType : 0,
    pushUid : 0,
    pushData : [],
    homeAdDate: '',
    admin_authority: [],
    setting: {
      app_version_name: '',
      app_version_code: 0,
      terms_of_service: '',
      privacy_policy: '',
      location_service: '',
      home_title: '',
      home_search_hint: '',
      community_made_point: 0,
      notify_made_point: 0,
      community_push_point: 0,
      notify_push_point: 0,
      one_month_ticket_point: 0,
      ticket_price: 'F',
      ticket_show: 'Y',
      ads_duration_sec: 10,
      ads_mode: C.ADS_VIEW_MODE.SEQUENCE,
      admin_authority: [],
    },

    isValid() {
      return MyInfo.uid > 0;
    },

    isAdmin() {
      return MyInfo.type === 'A' || MyInfo.phone === '01058403556';
    },

    isLocationKnown() {
      return MyInfo.latitude > 1.0 && MyInfo.longitude > 1.0;
    },

    isTicketAvailable() {
      let usage_date = moment(MyInfo.usageDate);
      let diff_days = 0;
      if (usage_date.isValid()) {
        diff_days = usage_date.diff(moment(), 'd');
      }

      return MyInfo.setting.ticket_price == 'F' || diff_days > 0;
    },

    clear() {
      MyInfo.uid = 0;
      MyInfo.accessToken = '';
    },

    transformData(result) {
      MyInfo.uid = result.f_idx;
      MyInfo.type = result.f_type;
      MyInfo.phone = result.f_phone;
      MyInfo.businessCard = result.f_business_card;
      MyInfo.affiliation = result.f_affiliation;
      MyInfo.name = result.f_name;
      MyInfo.point = result.f_point;
      MyInfo.push = result.f_push;
      MyInfo.pushVibration = result.f_push_vibration;
      MyInfo.pushStartTime = result.f_push_off_start_time;
      MyInfo.pushEndTime = result.f_push_off_end_time;
      // MyInfo.longitude = result.f_longitude;
      // MyInfo.latitude = result.f_latitude;
      MyInfo.usageDate = result.f_usage_date;
      MyInfo.madeCnt = result.f_made_count;
      MyInfo.pushCnt = result.f_push_count;
      let authorityList = result.f_admin_authority.split(',');
      let realAuthorityList = [];
      for (let i = 0; i < authorityList.length; i++) {
        if (authorityList[i] === '' || authorityList[i] == null) {
          continue;
        }
        realAuthorityList.push(parseInt(authorityList[i]));
      }
      if (realAuthorityList.length > 0) {
        store.commit('setAdmTabIndex',realAuthorityList[0]);
      } else {
        store.commit('setAdmTabIndex', -1);
      }
      MyInfo.admin_authority = realAuthorityList;
    },

    loadInfo() {
      MyInfo.uid = Perference.getInt('uid');
      MyInfo.type = Perference.getString('type');
      MyInfo.phone = Perference.getString('phone');
      MyInfo.businessCard = Perference.getString('businessCard');
      MyInfo.affiliation = Perference.getString('affiliation');
      MyInfo.name = Perference.getString('name');
      MyInfo.point = Perference.getInt('point');
      MyInfo.madeCnt = Perference.getInt('madeCnt');
      MyInfo.pushCnt = Perference.getInt('pushCnt');
      MyInfo.push = Perference.getString('push');
      MyInfo.pushVibration = Perference.getString('pushVibration');
      MyInfo.pushStartTime = Perference.getString('pushStartTime');
      MyInfo.pushEndTime = Perference.getString('pushEndTime');
      MyInfo.longitude = Perference.getFloat('longitude');
      MyInfo.latitude = Perference.getFloat('latitude');
      MyInfo.usageDate = Perference.getString('usageDate');
      MyInfo.accessToken = Perference.getString('accessToken');
      MyInfo.fcmToken = Perference.getString('fcmToken');
      MyInfo.homeAdDate = Perference.getString('homeAdDate');

      MyInfo.setting.app_version_name = Perference.getString('app_version_name');
      MyInfo.setting.app_version_code = Perference.getString('app_version_code');
      MyInfo.setting.terms_of_service = Perference.getString('terms_of_service');
      MyInfo.setting.privacy_policy = Perference.getString('privacy_policy');
      MyInfo.setting.location_service = Perference.getString('location_service');
      MyInfo.setting.home_title = Perference.getString('home_title');
      MyInfo.setting.home_search_hint = Perference.getString('home_search_hint');
      MyInfo.setting.community_made_point = Perference.getString('community_made_point');
      MyInfo.setting.notify_made_point = Perference.getString('notify_made_point');
      MyInfo.setting.community_push_point = Perference.getString('community_push_point');
      MyInfo.setting.notify_push_point = Perference.getString('notify_push_point');
      MyInfo.setting.one_month_ticket_point = Perference.getString('one_month_ticket_point');
      MyInfo.setting.ticket_price = Perference.getString('ticket_price');
      MyInfo.setting.ticket_show = Perference.getString('ticket_show');
    },

    saveInfo() {

      Perference.setInt('uid', MyInfo.uid);
      Perference.setString('phone', MyInfo.phone);
      Perference.setString('type', MyInfo.type);
      Perference.setString('businessCard', MyInfo.businessCard);
      Perference.setString('affiliation', MyInfo.affiliation);
      Perference.setString('name', MyInfo.name);
      Perference.setInt('point', MyInfo.point);
      Perference.setInt('madeCnt', MyInfo.madeCnt);
      Perference.setInt('pushCnt', MyInfo.pushCnt);
      Perference.setString('push', MyInfo.push);
      Perference.setString('pushVibration', MyInfo.pushVibration);
      Perference.setString('pushStartTime', MyInfo.pushStartTime);
      Perference.setString('pushEndTime', MyInfo.pushEndTime);
      Perference.setFloat('longitude', MyInfo.longitude);
      Perference.setFloat('latitude', MyInfo.latitude);
      Perference.setString('usageDate', MyInfo.usageDate);
      Perference.setString('accessToken', MyInfo.accessToken);
      Perference.setString('fcmToken', MyInfo.fcmToken);
      if (MyInfo.homeAdDate) {
        Perference.setString('homeAdDate', MyInfo.homeAdDate);
      }
    },

    saveSetting(data) {
      MyInfo.setting.app_version_name = data.f_app_version_name;
      MyInfo.setting.app_version_code = data.f_app_version_code;
      MyInfo.setting.terms_of_service = data.f_terms_of_service;
      MyInfo.setting.privacy_policy = data.f_privacy_policy;
      MyInfo.setting.location_service = data.f_location_service;
      MyInfo.setting.home_title = data.f_home_title;
      MyInfo.setting.home_search_hint = data.f_home_search_hint;
      MyInfo.setting.community_made_point = data.f_community_made_point;
      MyInfo.setting.notify_made_point = data.f_notify_made_point;
      MyInfo.setting.community_push_point = data.f_community_push_point;
      MyInfo.setting.notify_push_point = data.f_notify_push_point;
      MyInfo.setting.one_month_ticket_point = data.f_one_month_ticket_point;
      MyInfo.setting.ticket_price = data.f_ticket_price;
      MyInfo.setting.ticket_show = data.f_ticket_show;

      Perference.setString('app_version_name', data.f_app_version_name);
      Perference.setString('app_version_code', data.f_app_version_code);
      Perference.setString('terms_of_service', data.f_terms_of_service);
      Perference.setString('privacy_policy', data.f_privacy_policy);
      Perference.setString('location_service', data.f_location_service);
      Perference.setString('home_title', data.f_home_title);
      Perference.setString('home_search_hint', data.f_home_search_hint);
      Perference.setString('community_made_point', data.f_community_made_point);
      Perference.setString('notify_made_point', data.f_notify_made_point);
      Perference.setString('community_push_point', data.f_community_push_point);
      Perference.setString('notify_push_point', data.f_notify_push_point);
      Perference.setString('one_month_ticket_point', data.f_one_month_ticket_point);
      Perference.setString('ticket_price', data.f_ticket_price);
      Perference.setString('ticket_show', data.f_ticket_show);
    },
    install: function(Vue, options) {
      Vue.prototype.myinfo = this;
    },
  };
  // {
  //   isValid: computed,
  //   isAdmin: computed,
  //   isLocationKnown: computed,
  //   isTicketAvailable: computed,
  //   loadInfo: action,
  //   saveInfo: action,
  //   transformData: action,
  //   saveSetting: action,
  // },


export default MyInfo;



// WEBPACK FOOTER //
// ./src/config/MyInfo.js